// extracted by mini-css-extract-plugin
export default {"title":"de279f9159","bld":"d6eedfb06f"};